import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { GlobalContext } from "../contexts/GlobalContext";
import PageHeader from "../components/PageHeader";
import H2HFixtureComparison from "../components/H2HFixtureComparison";
import { faFutbol } from "@fortawesome/free-solid-svg-icons";

function H2HFixturePage() {
  const { globalSeasonId, globalGameweek } = useContext(GlobalContext);
  const { gameweek, team1Id, team2Id } = useParams();

  return (
    <div>
      <PageHeader pageTitle="H2H Fixture" gameweek={parseInt(gameweek)} icon={faFutbol} />
      <H2HFixtureComparison
        seasonId={globalSeasonId}
        gameweek={parseInt(gameweek)}
        globalGameweek={globalGameweek}
        team1Id={team1Id}
        team2Id={team2Id}
      />
    </div>
  );
}

export default H2HFixturePage;
